import { KitchenRole } from '../types';
import { updatedAtColumn } from './table.constants';

const kitchenLabels = [
  { value: 'OFFICE', option: 'Office' },
  { value: 'HOME', option: 'Home' },
  { value: 'OTHER', option: 'Other' },
  { value: 'WORK', option: 'Work' },
  { value: 'MAIN_KITCHEN', option: 'Main Kitchen' },
  { value: 'BRANCH_KITCHEN', option: 'Branch Kitchen' },
] as { value: string; option: string }[];

const kitchenStatus = [
  { value: 'ACTIVE', option: 'Active' },
  { value: 'INACTIVE', option: 'Inactive' },
  { value: 'CLOSED', option: 'Closed' },
  { value: 'FLAGGED', option: 'Flagged' },
] as { value: string; option: string }[];

export const StaffRole = [
  { value: 'DELIGHT_OFFICER', option: 'OFFICER' },
  { value: 'FINANCE', option: 'FINANCE' },
  { value: 'OWNER', option: 'OWNER' },
  { value: 'SERVER', option: 'OUTLET OFFICER' },
  { value: 'LOGISTICS', option: 'LOGISTICS' },
  { value: 'CUSTOMER_SUCCESS', option: 'CUSTOMER_SUCCESS' },
  { value: 'PHARMACIST', option: 'PHARMACIST' },
] as { value: KitchenRole; option: KitchenRole }[];

export const VendorStaffRole = [
  { value: 'FINANCE', option: 'FINANCE' },
  { value: 'OWNER', option: 'OWNER' },
] as { value: KitchenRole; option: KitchenRole }[];

const kitchensColumns = [
  {
    Header: 'Outlet name',
    accessor: 'outletName',
  },
  {
    Header: 'Vendors',
    accessor: 'vendor',
  },
  {
    Header: 'Outlet manager',
    accessor: 'outletOwner',
  },
  {
    Header: 'Location',
    accessor: 'outletLocation',
  },
  {
    Header: 'Status',
    accessor: 'statusDisplay',
  },
  {
    Header: 'Date created',
    accessor: 'createdAt',
  },
  updatedAtColumn,
  {
    Header: 'Actions',
    accessor: 'id',
  },
];

const DEFAULT_OPEN_TIME = '08:00';
const DEFAULT_CLOSE_TIME = '22:00';

const defaultHours = [
  { weekday: 1, isOpen: true, openTime: DEFAULT_OPEN_TIME, closeTime: DEFAULT_CLOSE_TIME },
  { weekday: 2, isOpen: true, openTime: DEFAULT_OPEN_TIME, closeTime: DEFAULT_CLOSE_TIME },
  { weekday: 3, isOpen: true, openTime: DEFAULT_OPEN_TIME, closeTime: DEFAULT_CLOSE_TIME },
  { weekday: 4, isOpen: true, openTime: DEFAULT_OPEN_TIME, closeTime: DEFAULT_CLOSE_TIME },
  { weekday: 5, isOpen: true, openTime: DEFAULT_OPEN_TIME, closeTime: DEFAULT_CLOSE_TIME },
  { weekday: 6, isOpen: true, openTime: DEFAULT_OPEN_TIME, closeTime: DEFAULT_CLOSE_TIME },
  { weekday: 7, isOpen: true, openTime: DEFAULT_OPEN_TIME, closeTime: DEFAULT_CLOSE_TIME },
];

const mapDayOfWeek = {
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
  7: 'Sun',
};

const kitchenLocation = {
  latitude: 6.4338405,
  longitude: 3.4688427,
};

export {
  kitchenLabels,
  kitchenStatus,
  kitchensColumns,
  defaultHours,
  DEFAULT_OPEN_TIME,
  DEFAULT_CLOSE_TIME,
  mapDayOfWeek,
  kitchenLocation,
};

export const kitchenTypes = [
  { name: '500chow Outlets', value: '500chow' },
  { name: 'Other Outlets', value: 'others' },
];

export const kitchenServices = [
  { value: 'DELIVERY', label: 'Delivery' },
  { value: 'PICKUP', label: 'Pickup' },
  { value: 'SCHEDULED', label: 'Scheduled' },
] as const;
